import { Component, Input, OnInit, forwardRef } from '@angular/core';
import {
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { PartnerService } from '@infrastructure/services/alpura/partner.service';
import { SelectPartnerComponent } from '../select-partner/select-partner.component';
import { Socio } from '@domain/models/socio.model';
import { Observable, map } from 'rxjs';
import { PlantService } from '@infrastructure/services/catalog/planta.service';
import { PlantasService } from '@infrastructure/services/catalog/plantas.service';

@Component({
  selector: 'app-select-facility',
  templateUrl: './select-facility.component.html',
  styleUrls: ['./select-facility.component.scss'],
  providers: [
    [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SelectFacilityComponent),
        multi: true,
      },
    ],
    PlantasService,
  ],
})
export class SelectFacilityComponent implements OnInit {
  @Input() value: string = '';
  @Input() showOptionAll: boolean = true;
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  public form: FormGroup = new FormGroup({
    facility: new FormControl(null, Validators.required),
  });

  plants$: Observable<any[]> = new Observable<any[]>();

  constructor(private plantService: PlantasService) {}

  ngOnInit(): void {
    this.obtenerDatos();
    this.form.get('facility')?.valueChanges.subscribe((data) => {
      this.onInput(!data || data == 'null' ? null : data);
    });
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onInput(value: string): void {
    this.value = value;
    this.onChange(value);
  }
  
  setDisabledState(isDisabled: boolean) {
    if(isDisabled) this.form.disable();
    else this.form.enable();
    
  }

  obtenerDatos() {
    this.plants$ = <Observable<Socio[]>>this.plantService.findAllPlantas();
    
  }
}
